/**
 * Хаб «Гостевой доступ» (персонал: owner/manager/front_desk).
 *
 * Точка входа раздела гостевого доступа: три самостоятельных экрана
 * (правило feedback_every_form_is_a_separate_screen):
 *   1. «Выдать гостевой доступ»  → /guest-access/grant   (GrantAccessPage)
 *   2. «Подтверждение доступа»    → /guest-access/pending (PendingApprovalsPage)
 *   3. «Список доступов»          → /guest-access/list    (AccessListPage)
 *
 * Каждый пункт — отдельный экран с «Назад», возвращающим в этот хаб.
 */
import { useNavigate } from 'react-router-dom';
import { Card } from '@hsc/ui';

interface HubItem {
  to: string;
  title: string;
  desc: string;
  testId: string;
}

const ITEMS: HubItem[] = [
  {
    to: '/guest-access/grant',
    title: 'Выдать гостевой доступ',
    desc: 'Создать доступ для гостя: номер, фамилия, даты — QR и ссылка на бота.',
    testId: 'hub-grant',
  },
  {
    to: '/guest-access/pending',
    title: 'Подтверждение доступа',
    desc: 'Очередь заявок от гостей, вошедших без активного доступа.',
    testId: 'hub-pending',
  },
  {
    to: '/guest-access/list',
    title: 'Список доступов',
    desc: 'Все гостевые доступы с фильтром по статусу и отменой.',
    testId: 'hub-list',
  },
];

export function GuestAccessHubPage(): JSX.Element {
  const navigate = useNavigate();
  return (
    <section data-testid="guest-access-hub" className="ga-page">
      <header className="staff-topbar">
        <div>
          <button
            type="button"
            className="ta-back-btn"
            onClick={() => navigate('/')}
            data-testid="ga-hub-back"
          >
            <span className="ta-back-btn__chev" aria-hidden="true">
              ‹
            </span>{' '}
            Назад
          </button>
          <h1 className="hsc-page__title staff-topbar__title">Гостевой доступ</h1>
        </div>
      </header>

      <div className="hsc-stack ga-hub-grid" data-testid="guest-access-hub-items">
        {ITEMS.map((it) => (
          <Card key={it.to}>
            <button
              type="button"
              className="ga-hub-card"
              onClick={() => navigate(it.to)}
              data-testid={it.testId}
            >
              <span className="ga-hub-card__title hsc-card__title">{it.title}</span>
              <span className="ga-hub-card__desc ta-muted">{it.desc}</span>
            </button>
          </Card>
        ))}
      </div>
    </section>
  );
}
